<template>
  <div v-if="showUpdateNotification" class="update-banner">
    🚀
    <b>Доступна новая версия!</b>
    <button class="update-btn" @click="applyUpdate">Обновить</button>
  </div>
</template>

<script>
export default {
  name: "AppUpdateNotification",
  data() {
    return {
      showUpdateNotification: false,
    };
  },
  methods: {
    showUpdateNotify() {
      this.showUpdateNotification = true;
    },

    async applyUpdate() {
      this.showUpdateNotification = false;

      try {
        // 1. Отключаем все service workers
        if ("serviceWorker" in navigator) {
          const registrations =
            await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            await registration.unregister();
          }
        }

        // 2. Очищаем кэш
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(
            cacheNames.map((cacheName) => caches.delete(cacheName))
          );
        }

        // 3. Перезагружаем с очисткой кэша
        setTimeout(() => {
          window.location.href =
            window.location.origin +
            window.location.pathname +
            "?v=" +
            Date.now();
        }, 100);
      } catch (error) {
        window.location.reload();
      }
    },
  },
  mounted() {
    window.showUpdateNotification = this.showUpdateNotify;
  },
};
</script>

<style scoped>
.update-banner {
  position: fixed;
  bottom: 16px;
  right: 16px;
  background: #222;
  color: #fff;
  border-radius: 6px;
  padding: 12px 24px;
  z-index: 10000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 20px;
}

.update-btn {
  background: #fff;
  color: #222;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
}
</style>
